import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 20px 30px;

    form {
        width: 100%;

        div + div {
            margin-top: 20px;
        }
    }

    button {
        margin: 20px 0 0 auto;
    }
`;
export { Container };